import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { EditPageTitleDialogData } from '@shared/interfaces/edit-page-title-dialog.interface';

@Component({
  selector: 'app-edit-page-title-dialog',
  templateUrl: './edit-page-title-dialog.component.html',
  styleUrls: ['./edit-page-title-dialog.component.scss']
})
export class EditPageTitleDialogComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<EditPageTitleDialogComponent>);
  private readonly fb = inject(FormBuilder);

  form: FormGroup;

  data: EditPageTitleDialogData = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.form = this.fb.group({
      title: [this.data.title, Validators.required],
      color: [this.data.color ?? '#222222'],
      date: [this.data.date ?? false],
      sport: [this.data.sport ?? false],
      athlete: [this.data.athlete ?? false],
      coach: [this.data.coach ?? false],
      testDisplayId: [this.data.testDisplayId ?? false],
      testType: [this.data.testType ?? false],
    });
  }

  getPageTitleColor(): string {
    return this.form.controls['color']?.value ?? "#222222";
  }

  onThemeColorChange(color: string): void {
    this.form.patchValue({
      color,
    });
  }

  onUpdate(): void {
    this.dialogRef.close(this.form.value as EditPageTitleDialogData);
  }
}
